// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-helper-ShIpAv{display:-ms-flexbox}.flex-1-helper-Q7chB6{-webkit-box-flex:1;-moz-box-flex:1;flex:1}.flex-direction-row-helper-osci3z{flex-direction:row}.flex-items-center-ILL8QQ{-ms-flex-align:center;align-items:center}.flex-justify-center-N94WvM{-webkit-box-pack:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.banner-wrapper-IYyBDT{background:#e5b65c;width:100%;min-height:48px;padding:0 64px}.banner-item-ythuzb{color:#fff;text-align:center;font-size:14px;font-weight:500;line-height:20px}.banner-upgrade-button-VjMApZ{cursor:pointer;text-underline-offset:4px;margin-left:6px;font-weight:700;-webkit-text-decoration-line:underline;text-decoration-line:underline}.close-t8y_kt{cursor:pointer;color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex-helper": `flex-helper-ShIpAv`,
	"flexHelper": `flex-helper-ShIpAv`,
	"flex-1-helper": `flex-1-helper-Q7chB6`,
	"flex1Helper": `flex-1-helper-Q7chB6`,
	"flex-direction-row-helper": `flex-direction-row-helper-osci3z`,
	"flexDirectionRowHelper": `flex-direction-row-helper-osci3z`,
	"flex-items-center": `flex-items-center-ILL8QQ`,
	"flexItemsCenter": `flex-items-center-ILL8QQ`,
	"flex-justify-center": `flex-justify-center-N94WvM`,
	"flexJustifyCenter": `flex-justify-center-N94WvM`,
	"banner-wrapper": `banner-wrapper-IYyBDT`,
	"bannerWrapper": `banner-wrapper-IYyBDT`,
	"banner-item": `banner-item-ythuzb`,
	"bannerItem": `banner-item-ythuzb`,
	"banner-upgrade-button": `banner-upgrade-button-VjMApZ`,
	"bannerUpgradeButton": `banner-upgrade-button-VjMApZ`,
	"close": `close-t8y_kt`
};
export default ___CSS_LOADER_EXPORT___;
